import { render, staticRenderFns } from "./SearchPromotions.vue.vue?vue&type=template&id=5728e657&scoped=true&"
import script from "./SearchPromotions.vue.vue?vue&type=script&lang=js&"
export * from "./SearchPromotions.vue.vue?vue&type=script&lang=js&"
import style0 from "./SearchPromotions.vue.vue?vue&type=style&index=0&id=5728e657&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5728e657",
  null
  
)

export default component.exports